import { render } from "./P_SwordAndShield.vue?vue&type=template&id=9709de22&scoped=true"
import script from "./P_SwordAndShield.vue?vue&type=script&lang=js"
export * from "./P_SwordAndShield.vue?vue&type=script&lang=js"

import "./P_SwordAndShield.vue?vue&type=style&index=0&id=9709de22&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9709de22"]])

export default __exports__